<div class="tab-bar">
  @if (canScroll()) {
    <button
      eBtn
      size="xs"
      compact
      squared
      type="button"
      icon="chevron-left"
      iconColor="primary-75"
      [attr.aria-label]="t('humanDesign.chart.controls.aria.scrollTabsLeft')"
      (click)="scrollByDirection(-1)"
    ></button>
  }

  <div
    #scroller
    class="tab-scroller"
    role="tablist"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="onDrop($event)"
    (wheel)="onWheel($event)"
  >
    @for (tab of tabs(); track tab.id) {
      <div
        class="tab"
        role="tab"
        cdkDrag
        [cdkDragDisabled]="viewport.isTouchPrimary()"
        cdkDragPreviewContainer="parent"
        [class.is-active]="tab.id === activeTabId()"
        [class.is-pressed]="tab.id === pressedTabId()"
        [class.is-loading]="tab.loading"
        [attr.aria-busy]="tab.loading || null"
        [attr.aria-selected]="tab.id === activeTabId()"
        [attr.data-tab-id]="tab.id"
        [attr.title]="tab.presetTooltip || null"
        (click)="tabSelected.emit(tab.id)"
        (contextmenu)="onTabContextMenu($event, tab.id)"
        (pointerdown)="onTabPointerDown($event, tab.id)"
        (pointerup)="onTabPointerUp()"
        (pointercancel)="onTabPointerUp()"
        (pointerleave)="onTabPointerUp()"
        (cdkDragStarted)="onDragStarted()"
      >
        <span class="tab-label">{{ tabLabel(tab) }}</span>
        @if (tab.shared) {
          <!-- Gedeelde chart, niet in de eigen library (spec 2026-10-20-chart-share §4.6). -->
          <i class="fas fa-share-nodes tab-shared-icon" [title]="t('humanDesign.chartShare.sharedTabTooltip')"
             aria-hidden="true" data-test-id="tab-shared-icon"></i>
        }
        <button
          eBtn
          size="xs"
          compact
          squared
          type="button"
          icon="xmark"
          iconColor="primary-75"
          class="tab-close"
          [attr.aria-label]="t('humanDesign.chart.controls.closeTab')"
          (click)="onCloseClick($event, tab.id)"
        ></button>
      </div>
    }
  </div>

  @if (canScroll()) {
    <button
      eBtn
      size="xs"
      compact
      squared
      type="button"
      icon="chevron-right"
      iconColor="primary-75"
      [attr.aria-label]="t('humanDesign.chart.controls.aria.scrollTabsRight')"
      (click)="scrollByDirection(1)"
    ></button>
  }

  <button
    type="button"
    class="tab-add"
    [attr.aria-label]="t('humanDesign.chart.controls.addTab')"
    [attr.title]="t('humanDesign.chart.controls.addTab')"
    (click)="addRequested.emit()"
  >
    <i eIcon icon="plus"></i>
  </button>

  <button
    type="button"
    class="tab-add tab-close-all"
    [attr.aria-label]="t('humanDesign.chart.controls.closeAllTabs')"
    [attr.title]="t('humanDesign.chart.controls.closeAllTabs')"
    (click)="closeAllTabsRequested.emit()"
  >
    <i eIcon icon="square-xmark"></i>
  </button>
</div>
